import { call, cancelled, put, select } from 'redux-saga/effects'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import getAPIConfig from '@/shared/tools/getAPIConfig'
import { updateConsumptionModuleConfiguration } from '../../../SubscriptionFormConfigurationSlice'
import * as Sentry from '@sentry/react'

export const consumptionModuleActions = {
  CONSUMPTION_MODULE_CALCULATE_PRICE: 'CONSUMPTION_MODULE_CALCULATE_PRICE',
}

export function* calculateOfferPrice({ url, params, callback, method, workflow }) {
  const controller = new AbortController()
  const { authTokenSession, lang } = yield select(selectAuthData)
  yield put(updateConsumptionModuleConfiguration({ offerPriceLoading: true }))
  let config
  try {
    const signal = controller.signal
    if (method === 'get') {
      config = yield call(getAPIConfig, { method, authTokenSession })
    } else {
      const entries = params.entries()
      const entriesParameters = Object.fromEntries(entries)
      config = yield call(getAPIConfig, { method, authTokenSession, body: entriesParameters })
    }
    const response = yield call(fetch, url + '?lang=' + lang, { ...config, signal })
    const isValid = response.status === 200
    yield put(updateConsumptionModuleConfiguration({ offerPriceLoading: false }))
    const responseData = yield call([response, response.json])
    if (!isValid) {
      if (import.meta.env.PROD) {
        Sentry.captureException(new Error('calculateOfferPriceError'), { extra: { responseData, status: response.status } })
      }
    }
    yield call(callback, responseData, workflow)
  } catch (error) {
    if (import.meta.env.PROD) {
      Sentry.captureException(new Error('calculateOfferPriceError'), { extra: { error } })
    }
  } finally {
    if (yield cancelled()) {
      controller.abort()
    }
  }
}
